export const USER = "USER"

export const USER_UPDATE = "USER_UPDATE"
export const USER_FETCH_ENTITIES = "USER_FETCH_ENTITIES"
export const USER_UPDATE_ENTITIES = "USER_UPDATE_ENTITIES"
